import IssueCtrl from '../../components/repo-issues/Issues/Issues';

export default function RepoIssues() {
	return <IssueCtrl />;
}
